// @flow

import { CALL_API } from 'constants/common';
import * as syndicateTypes from 'constants/syndicate';
import { SYNDICATE, MEMBER_SYNDICATE } from 'schema';

type SyndicateBody = {};

export const createSyndicate = (body: SyndicateBody) => ({
  [CALL_API]: {
    types: [
      syndicateTypes.CREATE_SYNDICATE_REQUEST,
      syndicateTypes.CREATE_SYNDICATE_SUCCESS,
      syndicateTypes.CREATE_SYNDICATE_FAILURE
    ],
    endpoint: '/create-syndicate/create_syndicate',
    method: 'POST',
    body
  }
});

export type CreateSyndicateFn = typeof createSyndicate;

export const updateSyndicate = (id: number, body: SyndicateBody) => ({
  [CALL_API]: {
    types: [
      syndicateTypes.UPDATE_SYNDICATE_REQUEST,
      syndicateTypes.UPDATE_SYNDICATE_SUCCESS,
      syndicateTypes.UPDATE_SYNDICATE_FAILURE
    ],
    endpoint: `/update-syndicate/${id}`,
    method: 'PATCH',
    body
  }
});

export type UpdateSyndicateFn = typeof updateSyndicate;

export const fetchSyndicate = (id: number) => ({
  [CALL_API]: {
    types: [
      syndicateTypes.FETCH_SYNDICATE_REQUEST,
      syndicateTypes.FETCH_SYNDICATE_SUCCESS,
      syndicateTypes.FETCH_SYNDICATE_FAILURE
    ],
    endpoint: `/get-syndicate/${id}`,
    method: 'GET',
    schema: SYNDICATE
  }
});

export type FetchSyndicateFn = typeof fetchSyndicate;

export const clearSyndicate = () => ({
  type: syndicateTypes.CLEAR_SYNDICATE
});

export type ClearSyndicateFn = typeof clearSyndicate;

export const fetchSyndicates = () => ({
  [CALL_API]: {
    types: [
      syndicateTypes.FETCH_SYNDICATES_REQUEST,
      syndicateTypes.FETCH_SYNDICATES_SUCCESS,
      syndicateTypes.FETCH_SYNDICATES_FAILURE
    ],
    endpoint: `/get-syndicate`,
    method: 'GET',
    schema: [SYNDICATE]
  }
});

export type FetchSyndicatesFn = typeof fetchSyndicates;

export const fetchMemberSyndicates = () => ({
  [CALL_API]: {
    types: [
      syndicateTypes.FETCH_MEMBER_SYNDICATES_REQUEST,
      syndicateTypes.FETCH_MEMBER_SYNDICATES_SUCCESS,
      syndicateTypes.FETCH_MEMBER_SYNDICATES_FAILURE
    ],
    endpoint: `/syndicate-member`,
    method: 'GET',
    schema: [MEMBER_SYNDICATE]
  }
});

export type FetchMemberSyndicatesFn = typeof fetchMemberSyndicates;

export const fetchMemberSyndicate = (id: number) => ({
  [CALL_API]: {
    types: [
      syndicateTypes.FETCH_MEMBER_SYNDICATE_REQUEST,
      syndicateTypes.FETCH_MEMBER_SYNDICATE_SUCCESS,
      syndicateTypes.FETCH_MEMBER_SYNDICATE_FAILURE
    ],
    endpoint: `/syndicate-member/${id}`,
    method: 'GET',
    schema: MEMBER_SYNDICATE
  }
});

export type FetchMemberSyndicateFn = typeof fetchMemberSyndicate;

type ConfirmInvitationBody = {
  token: string
};

export const confirmInvitation = (body: ConfirmInvitationBody) => ({
  [CALL_API]: {
    types: [
      syndicateTypes.CONFIRM_INVITATION_REQUEST,
      syndicateTypes.CONFIRM_INVITATION_SUCCESS,
      syndicateTypes.CONFIRM_INVITATION_FAILURE
    ],
    endpoint: `/create-syndicate/confirm_invite`,
    method: 'POST',
    body
  }
});

export type ConfirmInvitationFn = typeof confirmInvitation;

export default null;



// WEBPACK FOOTER //
// ./src/actions/syndicate.js